import { render, staticRenderFns } from "./nouveau.vue?vue&type=template&id=3bc8e0b4"
import script from "./nouveau.vue?vue&type=script&lang=ts"
export * from "./nouveau.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports